import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  computed: _objectSpread({}, mapState(['nbaVipIcon']))
};